import axios from 'axios'
import $ from 'cash-dom'
import { createStore } from 'redux'
import { Api } from './api'
import * as cart from './cart'
import * as utils from './utils'

const reducer = (
  state = {
    products: [],
    activeProduct: null,
    activeVariant: null,
    modalOpen: false,
    loading: false,
  },
  action
) => {
  switch (action.type) {
    case 'SET_PRODUCT':
      return { ...state, products: [...state.products, action.product] }
    case 'SET_ACTIVE_PRODUCT':
      const activeProduct = action.product
      const activeVariant = action.product.variants[0]
      return { ...state, activeProduct, activeVariant }
    case 'SET_ACTIVE_VARIANT':
      return { ...state, activeVariant: action.variant }
    case 'SET_LOADING':
      return { ...state, loading: action.loading }
    case 'OPEN_MODAL':
      return { ...state, modalOpen: true }
    case 'CLOSE_MODAL':
      return { ...state, modalOpen: false }
    default:
      return state
  }
}

const $els = {
  body: $('body'),
  modal: $('.quick-shop-modal'),
  close: $('.quick-shop-close'),
  image: $('.quick-shop-image'),
  title: $('.quick-shop-title'),
  price: $('.quick-shop-price'),
  vendor: $('.quick-shop-vendor'),
  url: $('.quick-shop-url'),
  compareAt: $('.quick-shop-compare-at'),
  trigger: $('.quick-shop-trigger'),
  options: $('.quick-shop-options'),
  add: $('.quick-shop-add'),
  out: $('.quick-shop-out'),
  loading: $('.quick-shop-loading'),
  content: $('.quick-shop-content'),
}

const store = createStore(reducer)

const render = () => {
  const state = store.getState()
  const { activeProduct, activeVariant } = state
  const hasVariants = utils.hasVariants(activeProduct)

  const renderOption = (option, idx) => {
    const optionIdx = idx + 1
    const activeValue = activeVariant
      ? activeVariant[`option${optionIdx}`]
      : option.values[0]
    return `
        <div>
          <legend class="block caption mb-2">
            <span class="text-gray-400">${option.name}:</span>
            <span class="active-variant-value">${activeValue}</span>
          </legend>
          ${option.values
            .map((val, i) => {
              const active = activeVariant?.options.includes(val)
              const imgClass = active ? 'text-black' : 'text-transparent'
              const textClass = active
                ? 'bg-white border-white shadow'
                : 'border-gray-300'
              const thumb = activeProduct.options[idx].thumbs[i]
              return thumb
                ? `
                <button class="quick-shop-option quick-option-img rounded-full w-12 h-12 p-1 transition-color duration-200 shadow-outline mr-1 mb-2 ${imgClass}" data-option${optionIdx}="${val}">
                  <img class="rounded-full" src="${thumb}" />
                </button>`
                : `
                <button class="quick-shop-option quick-option-text rounded-full h-10 px-6 border mr-1 mb-2 transition-all duration-200 hover:bg-white hover:border-white inline-block ${textClass}" data-option${optionIdx}="${val}">
                  <span class="font-mont-medium text-xs flex items-center uppercase">${val}</span>
                </button>
                `
            })
            .join('')}
        </div>
      `
  }

  const options = `
      <div class="border-t border-b border-gray-300 py-6 mt-4 grid gap-4">
        ${activeProduct?.options?.map(renderOption).join('')}
      </div>
    `

  if (state.modalOpen) {
    utils.show($els.modal)

    if (state.loading) {
      $els.loading.removeClass('hidden')
      $els.content.addClass('hidden')
    } else {
      $els.loading.addClass('hidden')
      $els.content.removeClass('hidden')
    }

    if (state.activeProduct) {
      const src =
        hasVariants && activeVariant?.featured_image
          ? activeVariant?.featured_image?.src
          : activeProduct?.images[0]
      $els.image.attr('src', src)

      if (
        activeProduct?.vendor !== 'Hadley Roma' &&
        activeProduct?.vendor !== 'Teddy Baldassarre Watches' &&
        activeProduct?.vendor !== 'Rado'
      ) {
        $els.vendor.show().text(activeProduct?.vendor)
      } else {
        $els.vendor.hide().text('')
      }

      $els.title.text(activeProduct?.title)

      $els.url.attr('href', activeProduct?.url)

      const price = activeVariant ? activeVariant?.price : activeProduct?.price
      const fmtPrice = utils.priceToCurrency(price)
      $els.price.text(fmtPrice)

      if (activeProduct?.compare_at_price) {
        const compareAt = activeVariant
          ? activeVariant?.compare_at_price
          : activeProduct?.compare_at_price
        const fmtCompareAt = utils.priceToCurrency(compareAt)
        $els.compareAt.text(fmtCompareAt).addClass('mr-2')
      } else {
        $els.compareAt.text('').removeClass('mr-2')
      }

      if (hasVariants) {
        $els.options.empty().append(options).removeClass('hidden')
      } else {
        $els.options.addClass('hidden').empty()
      }

      if (activeVariant?.available) {
        $els.add.removeClass('hidden')
        $els.out.addClass('hidden')
      } else {
        $els.add.addClass('hidden')
        $els.out.removeClass('hidden')
      }
    }
  } else {
    utils.hide($els.modal)
  }
}

render()
store.subscribe(render)

$els.close.on('click', () => {
  store.dispatch({ type: 'CLOSE_MODAL' })
})

$('body').on('click', '.quick-shop-option', (e) => {
  const { activeProduct, activeVariant } = store.getState()
  const nextOption = $(e.currentTarget).data()
  const nextVariant = { ...activeVariant, ...nextOption }
  const variant = activeProduct.variants.find(
    (variant) =>
      variant.option1 === nextVariant.option1 &&
      variant.option2 === nextVariant.option2 &&
      variant.option3 === nextVariant.option3
  )
  if (variant) {
    store.dispatch({
      type: 'SET_ACTIVE_VARIANT',
      variant,
    })
  }
})

$els.add.on('click', async () => {
  const { activeVariant } = store.getState()
  store.dispatch({ type: 'CLOSE_MODAL' })
  cart.openCart()
  await Api.addProduct(activeVariant.id)
  cart.updateCart()
})

const preloadProductData = async (handle) => {
  const state = store.getState()
  store.dispatch({ type: 'SET_LOADING', loading: true })
  store.dispatch({ type: 'OPEN_MODAL' })

  const viewedProduct = state.products.find((p) => p.handle === handle)
  if (viewedProduct) {
    store.dispatch({ type: 'SET_ACTIVE_PRODUCT', product: viewedProduct })
    store.dispatch({ type: 'SET_LOADING', loading: false })
    return
  }

  const resp = await Api.fetchProduct(handle)
  const html = await Api.fetchProductHtml(handle)
  const parser = new DOMParser()
  const doc = parser.parseFromString(html.data, 'text/html')
  const inputs = doc.querySelectorAll('.variant-input')
  const variantImages = Array.from(inputs).map((input) => {
    const $img = $(input).siblings('img')
    return $img.length > 0 ? $img.attr('src') : null
  })
  let idx = 0
  const product = {
    ...resp.data,
    options: resp.data.options?.map((option, i) => {
      const thumbs = variantImages.slice(idx, idx + option.values.length)
      idx += option.values.length
      return { ...option, thumbs }
    }),
  }

  store.dispatch({
    type: 'SET_PRODUCT',
    product,
  })
  store.dispatch({
    type: 'SET_ACTIVE_PRODUCT',
    product,
  })
  store.dispatch({
    type: 'SET_LOADING',
    loading: false,
  })
}

$('body').on('click', '.quick-shop-trigger', async (e) => {
  const handle = $(e.currentTarget).data('handle')
  const onlyVariant = $(e.currentTarget).data('onlyVariant')

  if (handle) {
    e.stopPropagation()
    e.preventDefault()
  }

  if (onlyVariant) {
    cart.openCart()
    document.dispatchEvent(new CustomEvent('cartOpened'))
    const resp = await Api.fetchProduct(handle)
    const id = resp.data.variants[0].id
    await Api.addProduct(id)
    await cart.updateCart()
    document.dispatchEvent(new CustomEvent('cartUpdated'))
    $(e.currentTarget).removeClass('adding')
    return
  }
  preloadProductData(handle)
})

$(document).on('keyup', (e) => {
  if (e.key === 'Escape') {
    store.dispatch({ type: 'CLOSE_MODAL' })
  }
})
